import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { useRef, useState } from "preact/hooks";
import "./Login.scss";
import { initializeApp } from "firebase/app";
import { collection, doc, getDoc, getFirestore } from "firebase/firestore";

const LoginComponent = () => {
    const [errorMessage, setErrorMessage] = useState<string>();
    const auth = getAuth();
    const emailRef = useRef(null);
    const passwordRef = useRef(null);

    const [user, setUser]       = useState<any>();
    const [profile, setProfile] = useState<any>();

    const [step, setStep] = useState<"login" | "register" | "profile">("login");

    const login = () => {
        
        const email    = emailRef?.current?.value;
        const password = passwordRef?.current?.value

        signInWithEmailAndPassword(auth, email, password).then((res) => {
            console.log('res', res);
            if (!res.user.emailVerified) {
                console.error('Email address not verified, please check your email');
            } else {
                setUser(res.user);
                setStep("profile");

                getUserData(res);
            }
        });
    };

    const getUserData = async (res: any) => {
        const firebaseConfig = {
            apiKey: "AIzaSyBK27hXh99cX7Qvh1PFieRPBPNRhj-Cv1c",
            authDomain: "retailconsultingteam-wobaby.firebaseapp.com",
            databaseURL: "https://retailconsultingteam-wobaby.firebaseio.com",
            projectId: "retailconsultingteam-wobaby",
            storageBucket: "retailconsultingteam-wobaby.appspot.com",
            messagingSenderId: "1070844699359",
            appId: "1:1070844699359:web:39a7fd9c3f8d08fbdc3f6a",
            measurementId: "G-N1CJ7MFJQ9"
        };

        const app = initializeApp(firebaseConfig);
        const db = getFirestore(app);

        const usersRef = collection(db, 'users');

        const docRef = doc(db, "users", res.user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap) {
            const user = docSnap.data();
            setProfile(user);
        }
    };

    return <div className={"login-container"}>

        {step === "login" ? <div className={"form-container"}>
            <h2>Login</h2>
            <input type="email" placeholder={"Email"} ref={emailRef}/>
            <input type="password" placeholder={"Password"} ref={passwordRef}/>
            <button onClick={login}>Login</button>
            <p>Don't have an account? <a href="#" onClick={() => setStep("register")}>Register here.</a></p>
        </div>
        : step === "register" ? <div className={"form-container"}>
            <input type="email" placeholder={"Email"} ref={emailRef}/>
            <input type="password" placeholder={"Password"} ref={passwordRef}/>
            <button onClick={login}>Register</button>
            <p>Already have an account? <a href="#" onClick={() => setStep("login")}>Login here.</a></p>
        </div>
        : step === "profile" && profile && <div className={"form-container profile"}>
            <h1>{profile.name}</h1>
            <h4>Points: {profile.points}</h4>
            <h4>Reward History:</h4>
            {profile.rewards && profile.rewards.map(reward => <div className={"reward-history"}>
                <div className={"reward-header"}>
                    <h3>{reward?.couponName}</h3>
                    <p>{reward?.date}</p>
                </div>
                <div className={"reward-body"}>
                    {reward?.approved ? <div className={"reward-approved"}>Approved</div>
                    : <div className={"reward-disapproved"}>Rejected</div>}
                </div>
            </div>)}
        </div>}


        {errorMessage && <div className={"error-message"}>
            {errorMessage}
        </div>}
    </div>
};

export default LoginComponent;